<template>
  <div class="comp-container comp-container__cell-input">
    <div class="row no-gutters justify-content-center">
      <div class="col col-md-6 col-lg-4">
        <transition
          name="animation-slide-in-bottom"
        >
          <div
            class="c-modal"
            v-if="show"
          >
            <div class="header">
              <div class="header__left"></div>
              <div class="header__title">{{ title }}</div>
              <div class="header__right" v-on:click="close()">
                <button><span class="material-icons">close</span></button>
              </div>
            </div>
            <div class="main">
              <div class="row no-gutters">
                <div class="col-5 cell-country__container">
                  <country-select
                    class="cell-country" v-on:select-country="selectedCountry($event)" :defaultCountry="cellCountry"
                  ></country-select>
                </div>
                <div class="col-7">
                  <input type="tel" class="cell" v-model="cell" :placeholder="$t('entry.common:mobileNumber')">
                </div>
              </div>
              <div v-html="$t('draw.acceptingOfTerms')" class="terms">
              </div>
            </div>
            <div class="footer POS-s">
              <button class="btn" :class="{ 'btn-loading': loading }" v-on:click="submit" :disabled="!isValidCell">
                {{ $t('common.submit') }}
                <div class="btn-loader"><span></span><span></span><span></span></div>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import AwesomePhonenumber from 'awesome-phonenumber';
import Cookies from 'js-cookie';

import CountrySelect from '@/components/Entry/Country-Select.vue';

export default {
  name: 'CellInput',
  props: {
    title: {
      type: String,
    },
    country: {
      type: String,
      default: 'TW',
    },
  },
  data() {
    return {
      cellCountry: 'TW',
      cell: '',

      show: false,
      code: null,

      loading: false,
    };
  },
  computed: {
    cellInstance() {
      return new AwesomePhonenumber(this.cell, this.cellCountry);
    },
    isValidCell() {
      return (this.cellInstance.isValid() && this.cellInstance.isMobile());
    },
  },
  mounted() {
    this.show = true;

    if (Cookies.get('input_cell')) {
      this.cell = Cookies.get('input_cell');
    }

    if (Cookies.get('input_cell_country')) {
      this.cellCountry = Cookies.get('input_cell_country');
    } else {
      this.cellCountry = this.country;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    selectedCountry(value) {
      this.cellCountry = value;
    },
    submit() {
      this.loading = true;

      if (process.env.NODE_ENV === 'development') {
        Cookies.set('input_cell', this.cell, { expires: 3560 });
        Cookies.set('input_cell_country', this.cellCountry, { expires: 3560 });
      } else {
        Cookies.set('input_cell', this.cell, { expires: 3560, domain: '.ocard.co' });
        Cookies.set('input_cell_country', this.cellCountry, { expires: 3560, domain: '.ocard.co' });
      }

      this.$emit('submit', this.cellInstance.getNumber());
    },
  },
  components: {
    CountrySelect,
  },
};
</script>

<style lang="sass" scoped>
.comp-container__cell-input
  width: 100%
  z-index: 1055
  overflow: auto
  display: flex
  flex-direction: column
  justify-content: flex-end
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0

  background-color: rgba(0, 0, 0, .25)

  user-select: none

  &::-webkit-scrollbar
    display: none

.c-modal
  padding: 16px
  bottom: 0
  display: flex
  flex-direction: column

  border-radius: 16px 16px 0 0

  background-color: white

  color: #333

.header
  display: flex
  align-items: center
  margin-bottom: 16px

  text-align: center

  &__left,
  &__title,
  &__right
    height: 32px

  &__left,
  &__right
    width: 32px

  &__title
    flex-grow: 1

    line-height: 32px
    font-weight: bold

  button
    padding: 4px
    width: 32px
    height: 32px

    border: none
    border-radius: 8px

    background-color: transparent

    color: #8D8D8D

    appearance: none
    outline: 0

    &:active
      background-color: #F5F5F5

      outline: 0

.main
  margin-bottom: 32px
  flex-grow: 1

.cell-country
  width: 100%
  padding: 10px 15px
  overflow: hidden

  border: none
  border-radius: 23px

  background-color: #ffea00
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAAwCAYAAACooNxlAAAABGdBTUEAALGPC/xhBQAAAYxJREFUaAXt1T9ugzAUBnAMQ5Zmh1vwZ2qToVvVC+Qulao26aWabjkBp4gEe3bo+9JYslCRYgPCSJ8lBwh5j+cfthMEbBSgAAUoQAEKUIACFKAABShAAQpQgAIUcBHIsuxd+qNLrBlTFMVW+pv53ZznkcvDZQBfSqm99F0cx6e6rs+OebZt235LntckSVRVVSeXPGPGWIPIrDjIAD5uRaxcUTAzbhgPyCV5nn1ACW11pfC2E7MOw/DHZvmkaboxMTr5Zr20niGY1niTeKNG5XfPFGAI4FHirzND5xCgQ1mWe30919EaBIW6ogAjiiLsGWtzwL5goCYnEATaomgMCfUWA+NyBkHwvSiC8SQz4yghXmNgTAofQ1ue5/gL/uzkuTRN8yLLQS0FA/WPAoJEfSi4J837mfFX5sAlo5Pg2Ld85NbK/J1PG6hZlz4ftIfoJPrYg6JvB75joNBRQZCwD2UJGJOA/IeyFAzUPmnDRos+6UOYnAIUoAAFKEABClCAAhSgAAUoQAEKUGCQwC/1HLKALR1EkwAAAABJRU5ErkJggg==')
  background-size: 24px
  background-repeat: no-repeat
  background-position: right center

  font-weight: 700
  color: #333

  -webkit-padding-end: 24px
  appearance: none
  text-overflow: ellipsis
  white-space: nowrap

  &:disabled
    opacity: 1

    background-image: none

  &__container
    height: 44px

    border-radius: 23px 0 0 23px

    background-color: #f5f5f5

  &::after
    content: ''

  &:focus
    outline: none

.desc
  margin: 16px 0 24px
  text-align: center

.cell[type=tel]
  width: 100%
  height: 100%
  padding: 0 12px

  border-radius: 0 23px 23px 0

  border: 0

  background-color: #f5f5f5

  font-weight: 700
  color: #333

  appearance: none
  outline: none

.terms
  margin-top: 16px
  text-align: center

  font-size: 0.75rem

  &::v-deep a
    color: currentColor
    text-decoration: underline

.footer
  display: flex

  button
    flex-grow: 1

  .btn
    position: relative
    padding: 10px
    display: block
    width: 100%
    box-shadow: none

    border-radius: 99px

    background-color: #ffea00

    color: #333
    font-weight: bold
    font-size: 1.125em

    &:active
      opacity: .5

      transform: scale(.95)

    &:disabled
      opacity: 1

      background-color: #f5f5f5

      color: rgba(0, 0, 0, .25)

      cursor: not-allowed

    &.btn-loading
      pointer-events: none

      .btn-loader
        display: block

    .btn-loader
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      border-radius: 99px
      display: none

      background-color: inherit

      &.inverse
        span
          background-color: white

      span
        display: inline-block
        width: 10px
        height: 10px
        border-radius: 100%
        background-color: #575757
        margin: 18px 5px
        opacity: 0

        &:nth-child(1)
          animation: opacitychange .5s ease-in-out infinite

        &:nth-child(2)
          animation: opacitychange .5s ease-in-out .166666667s infinite

        &:nth-child(3)
          animation: opacitychange .5s ease-in-out .333333334s infinite

        @keyframes opacitychange
          0%, 100%
            opacity: 0

          60%
            opacity: 1
</style>
